import { render, staticRenderFns } from "./MatchModal.vue?vue&type=template&id=33a5ac94&scoped=true&"
import script from "./MatchModal.vue?vue&type=script&lang=js&"
export * from "./MatchModal.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/match-modal.scss?vue&type=style&index=0&id=33a5ac94&scoped=true&lang=scss&"
import style1 from "@/sass/07_elements/multiselect.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a5ac94",
  null
  
)

export default component.exports